import { FC } from 'react';

type Props = {
	isEligible: boolean;
	isLoading: boolean;
	discountPercentage: number;
	textOverride?: string;
};

export const AchDiscountNotice: FC<Props> = ({ isEligible, isLoading, discountPercentage, textOverride }) => {
	if (!isEligible) {
		return null;
	}

	const message =
		textOverride ??
		`This payment is eligible for a ${discountPercentage}% discount on monthly fees if paying the full invoice amount.`;

	if (isLoading) {
		return (
			<p
				style={{
					fontWeight: 'bold',
					fontSize: '12px',
				}}
			>
				Checking ACH discount eligibility...
			</p>
		);
	}

	return (
		<p
			style={{
				fontWeight: 'bold',
				fontSize: '12px',
			}}
		>
			{message}
		</p>
	);
};
